import React, { Component } from "react";
import { id_camaba, parserText } from "../../../config/utils";
import { AjukanKrs, getListPengajuan, getOptPengajuan, setStatusKrs, validasiKrs } from "../../../services/api-services/krs-api";
import { sendMessage } from "../../../config/utils/message";
import $ from 'jquery';
import { API_MHS_KRS } from "../../../services/key/api";
import { KEY_MHS_KRS } from "../../../services/key/api_key";
import swal from 'sweetalert';

const statusKrs = {
  setujui: 'setujui',
  pengajuan: 'pengajuan',
  tolak: 'tolak',
  hapus: 'hapus'
}

class PengajuanKrs extends Component {

  state = {
    matkul: {
      listMatkul: [],
      batas_sks: '',
      ipslalu: ''
    },
    check_list: [],
    pengajuan: {
      listPengajuan: [],
      sks_semesterini: ''
    },
    iddetpeng: [],
    isLoading: false,
    isPengajuan: false,
    showModal: true,
    showModal: false,
    formdata: {
      nama: "",
      tgl_lahir: "",
      nik: "",
      nowa: "",
      email: "",
      jalan: ""
    }
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  onChangeInput = (e) => {
    this.setState({
      formdata: {
        ...this.state.formdata,
        [e.target.name]: e.target.value
      }
    })
  }

  handleChangeBiodata = (e) => {
    this.setState({
      formdata: {
        ...this.state.formdata,
        [e.target.name]: e.target.value
      }
    })
  };

  handleSubmit = () => {
    this.setState({ isLoad2: true });
    API_MHS_KRS.post('core-mhs/biodata/mhs/' + id_camaba + KEY_MHS_KRS, this.state.formdata)
      .then((res) => {
        console.log('Response:', res);
        if (res.status === 200) {
          this.setState({ isLoad2: false });
          swal({
            icon: 'success',
            title: 'Update Berhasil',
            text: 'Data telah diperbaharui!'
          }).then(() => {
            window.location.reload();
            this.closeModal();
          });
        } else {
          this.setState({ isLoad2: false });
          swal({
            icon: 'error',
            title: 'Gagal Update',
            text: 'Internal Server Error!'
          });
        }
      });
  };

  cekKRS = async () => {
    const params = this.props.location.state;
    const response = await validasiKrs(params.idangkt, params.idjalur);

    if (response.data.ispengajuan) {
      this.getAllData();
      this.setState({ showModal: true });
    } else {
      sendMessage(413);
    }
  };

  getBiodata = () => {
    API_MHS_KRS.get('core-mhs/biodata/mhs/' + id_camaba + KEY_MHS_KRS).then((res) => {
      this.setState({
        formdata: {
          ...res.data.content
        }
      }, () => {
        localStorage.setItem('nama', this.state.formdata.nama)
      })
    })
  }


  getAllData = async () => {
    $('.cekKRS').prop("checked", false);
    $('.cekMK').prop("checked", false);
    const { angkatan, kdjur, kurikulum, nim, semester, smtta, ta } = this.props.location.state

    const allPromise = Promise.all([
      getOptPengajuan(smtta, semester, kdjur, kurikulum, angkatan, ta, nim),
      getListPengajuan(nim, semester)
    ])

    const promises = await allPromise

    this.setState({
      matkul: {
        ...promises[0].data,
        listMatkul: promises[0].data.data.filter(val => {
          return !promises[1].data.data.find((selectedMK) => { return val.kodemk === selectedMK.kodemk })
        })
      },
      pengajuan: {
        ...promises[1].data,
        listPengajuan: promises[1].data.data
      },
      check_list: [],
      iddetpeng: []
    })
  }

  toggleCheckbox = (event, selectedVal) => {
    const data = {
      idmk: selectedVal.idmk,
      bu: selectedVal.bu,
      sks_total: selectedVal.sks_total
    }

    if (event.target.checked) {
      this.state.check_list.push(data)
    } else {
      var index = this.state.check_list.findIndex(x => x.idmk === data.idmk);
      this.state.check_list.splice(index, 1);
    }
  }

  toggleCheckboxKRS = (event) => {
    if (event.target.checked) {
      this.state.iddetpeng.push(event.target.value)
    } else {
      var index = this.state.iddetpeng.indexOf(event.target.value);
      this.state.iddetpeng.splice(index, 1);
    }
  }

  setPengajuan = async (type) => {
    if (this.state.iddetpeng.length === 0) {
      sendMessage(408)
    }
    else {
      this.setState({ isLoading: true })

      const response = await setStatusKrs({ check_list: this.state.iddetpeng }, type)
      if (response) {
        sendMessage(response.data[0].status_code)
          .then(() => {
            this.getAllData()
            this.setState({ isLoading: false })
          })
      }
    }
  }

  ProcessPengajuan = async () => {
    const { pengajuan, matkul } = this.state
    // total sks yang akan diajukan + total sks yang sudah diajukan
    const totalSksDiajukan = this.state.check_list.map(x => x.sks_total).reduce((a, b) => a + b, 0) + pengajuan.sks_semesterini

    if (this.state.check_list.length === 0) {
      sendMessage(408)
    }
    else if (totalSksDiajukan > matkul.batas_sks) {
      sendMessage(410)
      this.getAllData()
    }
    else {
      this.setState({ isPengajuan: true })
      const { nim, semester, smtta, ta, kurikulum } = this.props.location.state
      const { batas_sks } = matkul
      const data = {
        ta: ta,
        smtta: smtta,
        semester: semester,
        nim: nim,
        batas_sks: batas_sks,
        kurikulum: kurikulum,
        check_list: this.state.check_list
      }
      const response = await AjukanKrs(data)
      if (response) {
        sendMessage(response.data.status_code)
          .then(() => {
            this.getAllData()
            this.setState({ isPengajuan: false })
          })
      }
    }
  }

  componentDidMount = () => {
    this.cekKRS();
    this.getBiodata();
  };

  render() {
    const { angkatan, jurusan, nama, nim, semester, ta, nik } = this.props.location.state
    const { listMatkul, batas_sks, ipsLalu } = this.state.matkul
    const { listPengajuan } = this.state.pengajuan

    const statusTheme = (val) => {
      if (val === 'Disetujui') return 'success'
      else if (val === 'Ditolak') return 'danger'
      else if (val === 'Aktif') return 'info'
      else if (val === 'Konversi') return 'warning'
      else return 'primary'
    }

    return (
      <div className="smooth mb-2">
        {this.state.showModal && (
          <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: "rgba(0, 0, 0, 0.6)", overflowY: "scroll" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title"><strong>{this.state.formdata.nim} | {this.state.formdata.nama}</strong></h5>
                </div>
                <div className="modal-body">
                  <p><strong><span className="text-primary">Perbarui data identitas anda, jika ada perubahan pada kolom-kolom di bawah ini guna keperluan pengkinian data pada dikti.</span></strong></p>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Nomor Induk Kependudukan (NIK)</label>
                        <input
                          type="number"
                          name="nik"
                          defaultValue={this.state.formdata.nik}
                          onChange={this.handleChangeBiodata}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Tempat Tanggal/Lahir</label>
                        <input
                          type="date"
                          name="tgl_lahir"
                          defaultValue={this.state.formdata.tgl_lahir}
                          onChange={this.handleChangeBiodata}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Nomor Whatsapp</label>
                        <input
                          type="number"
                          name="nowa"
                          defaultValue={this.state.formdata.nowa}
                          onChange={this.handleChangeBiodata}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          defaultValue={this.state.formdata.email}
                          onChange={this.handleChangeBiodata}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Alamat Asal</label>
                        <textarea
                          name="jalan"
                          defaultValue={this.state.formdata.jalan}
                          onChange={this.handleChangeBiodata}
                          className="form-control"
                          required
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleSubmit}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => this.setState({ showModal: false })}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="col-md-12 mb-3">
          <div className="row">
            <div className="col-12 col-xl-8 mb-xl-0">
              <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Kartu Rencana Studi&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Pengajuan KRS
              </p>
            </div>
          </div>
        </div>

        <div className="card card-custom">
          <div className="card-body">
            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
              Pengajuan KRS
            </p>
            <div className="table-responsive">
              <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                <thead></thead>
                <tbody>
                  <tr>
                    <td>NIM</td>
                    <td> : </td>
                    <td>{nim}</td>

                    <td>Angkatan</td>
                    <td> : </td>
                    <td>{angkatan}</td>
                  </tr>
                  <tr>
                    <td>Nama</td>
                    <td> : </td>
                    <td>{parserText(localStorage.getItem('nama'))}</td>

                    <td>Tahun Akademik</td>
                    <td> : </td>
                    <td>{ta}</td>
                  </tr>
                  <tr>
                    <td>Prodi</td>
                    <td> : </td>
                    <td>{jurusan}</td>
                    <td>Semester</td>
                    <td> : </td>
                    <td>{semester}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <br />
            <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
              Mata kuliah diajukan :
            </p>
            <div className="table-responsive">
              <table className="display expandable-table tableBord" style={{ width: "100%" }}>
                <thead></thead>
                <tbody>
                  <tr>
                    <td width="180px">Total SKS MK Aktif</td>
                    <td width="10px"> : </td>
                    <td width="250px">{this.state.pengajuan.sks_aktif}</td>

                    <td width="180px">Total SKS MK Ditolak</td>
                    <td width="10px"> : </td>
                    <td width="180px">{this.state.pengajuan.sks_tolak}</td>
                  </tr>
                  <tr>
                    <td>Total SKS MK Disetujui</td>
                    <td> : </td>
                    <td>{this.state.pengajuan.sks_setuju}</td>

                    <td>Total SKS MK Keseluruhan</td>
                    <td> : </td>
                    <td>{this.state.pengajuan.sks_semesterini}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-responsive mt-3">
              <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>
                      <div style={{ display: "flex" }}>
                        <span style={{ marginTop: "-3px" }}>Pilih</span>
                      </div>
                    </th>
                    <th>No</th>
                    <th>Kode MK</th>
                    <th>Mata Kuliah</th>
                    <th>SKS Teori</th>
                    <th>SKS Praktek</th>
                    <th>Status</th>
                    <th>B/U</th>

                  </tr>
                </thead>
                <tbody>
                  {
                    listPengajuan.length !== 0 ? listPengajuan.map((his, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            {
                              (his.statuskrs !== 'Aktif' && his.statusbayar !== 'Y') &&
                              <input
                                onClick={this.toggleCheckboxKRS}
                                type="checkbox"
                                className="cekKRS"
                                disabled={this.state.isLoading}
                                value={his.idkrs}
                              />
                            }
                          </td>
                          <td>{index + 1}</td>
                          <td>{his.kodemk}</td>
                          <td>{his.namamk}</td>
                          <td>{his.sksteori}</td>
                          <td>{his.skspraktek}</td>
                          <td><span className={`badge badge-${statusTheme(his.statuskrs)}`} style={{ fontSize: '14px' }}>{his.statuskrs}</span></td>
                          <td>{his.bu}</td>
                        </tr>
                      )
                    }) : <tr><td colSpan="8"><center>Belum mengajukan mata kuliah</center></td></tr>
                  }
                </tbody>
              </table>
            </div>
            <br />
            <p align="right">
              <button className="btn btn-danger" onClick={() => this.setPengajuan(statusKrs.hapus)} disabled={this.state.isLoading}>
                hapus
              </button>
            </p>
          </div>
        </div>

        {/* mata kuliah pilihan  */}
        <div className="card card-custom mt-3">
          <div className="card-body">
            <p className="card-title" style={{ fontSize: "16px", marginTop: "10px", marginBottom: "25px", marginLeft: '0.5%' }}>
              Pilihan Mata Kuliah Untuk diajukan :
            </p>
            <div className="table-responsive">
              <table
                className="display expandable-table tableBord table-striped"
                style={{ width: "100%" }}
              >
                <thead></thead>
                <tbody>
                  <tr>
                    <td width="180px">IP Semester Lalu</td>
                    <td width="10px"> : </td>
                    <td width="260px">{ipsLalu}</td>
                    <td width="180px">Maksimal SKS semester ini</td>
                    <td width="10px"> : </td>
                    <td width="180px">{batas_sks}</td>
                  </tr>
                  <tr>
                    <td>Tahun Akademik</td>
                    <td> : </td>
                    <td>{ta}</td>
                    <td>Semester Saat Ini</td>
                    <td> : </td>
                    <td>{semester}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="table-responsive mt-3">
              <table id="MK" className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>
                      <div style={{ display: "flex" }}>
                        <span style={{ marginTop: "-3px" }}>Pilih</span>
                      </div>
                    </th>
                    <th data-orderable="false">Kode MK</th>
                    <th data-orderable="false">Mata Kuliah</th>
                    <th data-orderable="false">SKS Teori</th>
                    <th data-orderable="false">SKS Praktek</th>
                    <th>Semester</th>
                    <th data-orderable="false">B/U</th>
                    <th data-orderable="false">MK Prasyarat</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    listMatkul.length !== 0 ?
                      listMatkul.map((v, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <input
                                type="checkbox"
                                onChange={(e) => this.toggleCheckbox(e, v)}
                                className="cekMK"
                                disabled={this.state.isLoading}
                              />
                            </td>
                            <td>{v.kodemk}</td>
                            <td>{v.namamk}</td>
                            <td>{v.sksteori}</td>
                            <td>{v.skspraktek}</td>
                            <td>{v.semester}</td>
                            <td>{v.bu}</td>
                            <td>
                              <ul>
                                {v.mkpras.prasarat_satu && <li>{v.mkpras.prasarat_satu}</li>}
                                {v.mkpras.prasarat_dua && <li>{v.mkpras.prasarat_dua}</li>}
                                {v.mkpras.prasarat_tiga && <li>{v.mkpras.prasarat_tiga}</li>}
                              </ul>
                            </td>
                          </tr>
                        )
                      }) : <tr><td colSpan={9} className='text-center'>Tidak Ada Data</td></tr>
                  }
                </tbody>
              </table>
            </div>
            <br />
            {
              listMatkul.length !== 0 ?
                <p align="right">
                  <button className="btn btn-success" onClick={this.ProcessPengajuan} disabled={this.state.isPengajuan}>
                    pengajuan
                  </button>
                </p> : null
            }
          </div>
        </div>
        {/* end mata kuliah pilihan  */}

      </div>
    );
  }
}

export default PengajuanKrs;
